import { render, staticRenderFns } from "./SLAMetrics.vue?vue&type=template&id=786f59c5&scoped=true"
import script from "./SLAMetrics.vue?vue&type=script&lang=js"
export * from "./SLAMetrics.vue?vue&type=script&lang=js"
import style0 from "./SLAMetrics.vue?vue&type=style&index=0&id=786f59c5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786f59c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('786f59c5')) {
      api.createRecord('786f59c5', component.options)
    } else {
      api.reload('786f59c5', component.options)
    }
    module.hot.accept("./SLAMetrics.vue?vue&type=template&id=786f59c5&scoped=true", function () {
      api.rerender('786f59c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/SLAMetrics.vue"
export default component.exports